import React from 'react';
import { useTranslation } from 'react-i18next';
import { authButtonStyle } from '../constants/authStyles';

/** Geri düğmesi + ortalanmış auth-header; `header` verilirse title/subtitle yok sayılır. */
const AuthSelectionToolbar = ({
  onBack,
  backLabel,
  buttonStyle,
  title,
  subtitle,
  header,
  className = '',
  headerClassName = '',
  leadingExtra = null,
}) => {
  const { t } = useTranslation('common');
  const resolvedBackLabel = backLabel ?? t('back');
  const resolvedButtonStyle = buttonStyle ?? authButtonStyle;
  const toolbarClassName = ['auth-selection-toolbar', className].filter(Boolean).join(' ');
  const resolvedHeaderClassName = ['auth-header', headerClassName].filter(Boolean).join(' ');

  const showSubtitle =
    subtitle != null &&
    (typeof subtitle !== 'string' || subtitle.trim() !== '');

  return (
    <div className={toolbarClassName}>
      <div className="auth-selection-toolbar-leading">
        <button
          type="button"
          className="auth-button auth-button--compact"
          style={resolvedButtonStyle}
          onClick={onBack}
        >
          {resolvedBackLabel}
        </button>
        {leadingExtra}
      </div>
      <div className={resolvedHeaderClassName}>
        {header ?? (
          <>
            <h1>{title}</h1>
            {showSubtitle ? <p>{subtitle}</p> : null}
          </>
        )}
      </div>
    </div>
  );
};

export default AuthSelectionToolbar;
